/**
 * Resolves a media URL returned by the API to an absolute URL
 * using the configured API base URL.
 */
export function getMediaUrl(url: string, apiUrl: string): string {
  try {
    const path = new URL(url).pathname;
    const base = apiUrl.replace(/\/api$/, '');
    return base + path;
  } catch {
    return url;
  }
}
